import { getRequest } from "../http/HttpRequest";
import { AvailableDateType, BookingToReturn, LocationType } from "./types";

export const getLocations = async (organizationId: string) => {
  try {
    const response = await getRequest(
      "locations?organizationId=" + organizationId
    );

    const locations: LocationType[] = !!response && response.data.locations;

    return locations;
  } catch (e) {
    return undefined;
  }
};

export const getCalendar = async (month: number, orgId: string) => {
  try {
    const response = await getRequest(
      "availableDates?month=" + month + "&organization=" + orgId
    );

    const availableDates: AvailableDateType[] =
      !!response && response.data.availableDates;

    return availableDates;
  } catch (e) {
    return undefined;
  }
};

export const getAppointment = async (id: string) => {
  try {
    const response = await getRequest("appointments/get?id=" + id);

    const appointment: BookingToReturn = response.data.appointment;

    return appointment;
  } catch (e) {
    return undefined;
  }
};
